module.exports = __webpack_public_path__ + "static/caepco-e9fbf317f0dafe7bbf12f0fd0f1c3a48.png";